import { render } from "./TrainingRequistionControl.vue?vue&type=template&id=63746c85"
import script from "./TrainingRequistionControl.vue?vue&type=script&lang=js"
export * from "./TrainingRequistionControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__